import React from 'react'
import { Box, Typography } from 'transfix-ui/core'
import {
  IDocumentListWrapperProps,
  IBaseFileType,
  IFile,
  TFileType,
} from 'apps/fleet-planner/types'
import { UploadInputOverflowMenu } from '../atoms/UploadInputOverflowMenu'
import { DocumentList } from './DocumentList'

/**
 * Maps through files to rename them based on how many
 * previous files exist with that key
 */
const getFilesWithScaleTicketCount = (
  existingFiles: IBaseFileType[] = [],
  newFiles: IFile[] = []
): IFile[] => {
  const initialCount = existingFiles?.filter(d => d?.key === 'ScaleTicket').length || 0
  return newFiles.map((document, index) => {
    const count = initialCount + index + 1
    return {
      ...document,
      fileFileName: `Scale Ticket${initialCount > 0 ? ` ${count}` : ''}`,
    }
  })
}

const getDocumentTitle = (document: IBaseFileType): string => {
  const { fileName = '' } = document || {}
  return fileName
}

/**
 * Displays POD files from Marketplace's IShipment['documents']
 * @note These documents cannot be deleted or replaced
 */
export function DocumentScaleTicketList<T extends IBaseFileType>({
  documents: documentsProp = [],
  onChange,
  isLoading = false,
}: IDocumentListWrapperProps<T>) {
  const uploadHandler = (files: IFile[], fileType?: TFileType) => {
    if (fileType === 'scale_ticket') {
      const renamedFiles = getFilesWithScaleTicketCount(documentsProp, files)
      onChange(renamedFiles, fileType)
    } else if (fileType) {
      onChange(files, fileType)
    }
  }

  return (
    <Box>
      <Box mb={1}>
        <Typography variant='subtitle2'>Scale Tickets and Other Documents</Typography>
      </Box>
      <DocumentList
        fileType='scale_ticket'
        isEditable={false}
        documentName='Scale Ticket'
        documents={documentsProp}
        getDocumentTitle={getDocumentTitle}
        UploadComponent={
          <Box pt={2} pb={2} display='flex' alignItems='center'>
            <Box flex='0 0 auto'>
              <UploadInputOverflowMenu
                onUpload={uploadHandler}
                label='Upload...'
                disabled={isLoading}
              />
            </Box>
            <Box flex='1 1 auto' ml={2}>
              {isLoading ? (
                <Typography variant='subtitle2' color='textSecondary' component='span'>
                  Uploading file...
                </Typography>
              ) : (
                ''
              )}
            </Box>
          </Box>
        }
      />
    </Box>
  )
}
